/**
 * ============================================================================
 * TRANSACTION DETAIL PAGE - Dashboard-style layout
 * ============================================================================
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { UserDashboardLayout } from '../components/user';
import { useI18n } from '../providers';
import TransactionDetails from '../components/transaction/TransactionDetails';
import '../styles/landing.css';

const TransactionDetail = () => {
  const navigate = useNavigate();
  const { language } = useI18n();

  return (
    <UserDashboardLayout hideFooter>
      <div className="dashboard-wt dashboard-wt-fit-viewport">
        {/* Hero - same style as Dashboard / Create Transaction */}
        <section className="dashboard-wt-hero">
          <div className="dashboard-wt-hero-bg" aria-hidden="true" />
          <div className="dashboard-wt-hero-grid" aria-hidden="true" />
          <div className="dashboard-wt-hero-noise" aria-hidden="true" />
          <div className="dashboard-wt-hero-orb dashboard-wt-hero-orb-1" aria-hidden="true" />
          <div className="dashboard-wt-hero-orb dashboard-wt-hero-orb-2" aria-hidden="true" />
          <div className="dashboard-wt-hero-inner">
            <button
              type="button"
              onClick={() => navigate('/transactions')}
              className="dashboard-wt-btn-link mb-2 block text-left"
            >
              ← {language === 'fr' ? 'Retour aux transactions' : 'Back to Transactions'}
            </button>
            <h1 className="dashboard-wt-hero-title">
              📦 <span>{language === 'fr' ? 'Détails de la transaction' : 'Transaction Details'}</span>
            </h1>
            <p className="dashboard-wt-hero-sub">
              {language === 'fr'
                ? 'Consultez les détails et actions de votre transaction'
                : 'View details and actions for your transaction'}
            </p>
          </div>
        </section>

        {/* Content */}
        <section className="dashboard-wt-section dashboard-wt-section-alt">
          <div className="dashboard-wt-section-inner">
            <div className="tx-detail-wrap">
              <TransactionDetails />
            </div>
          </div>
        </section>
      </div>
    </UserDashboardLayout>
  );
};

export default TransactionDetail;
